import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import './Zone.css';

const url = process.env.REACT_APP_BACKEND_URL;

const Zone = () => {
    const [submitting, setSubmitting] = useState(false);
    const [data, setData] = useState({ name: "" });
    const navigate = useNavigate();

    const onChangeHandler = (event) => {
        const { name, value } = event.target;
        setData(prevData => ({ ...prevData, [name]: value }));
    };

    const onSubmitHandler = async (event) => {
        event.preventDefault();

        if (!data.name.trim()) {
            toast.error("Zone name is required");
            return;
        }

        try {
            setSubmitting(true);
            const response = await axios.post(`${url}/api/zone`, { name: data.name.trim() });

            if (response.data.success) {
                toast.success("Zone added successfully!");
                setData({ name: "" });
                navigate('/ViewZone');
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Failed to add zone";
            toast.error(errorMessage);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="district-container">
            <div className="header">
                <h2>Add New Zone</h2>
                <button 
                    onClick={() => navigate('/ViewZone')}
                    className="add-button"
                >
                    <Plus size={16} /> View Zones
                </button>
            </div>

            <form className="district-form" onSubmit={onSubmitHandler}>
                <div className="form-group">
                    <label>Zone Name</label>
                    <input
                        type="text"
                        name="name"
                        value={data.name}
                        onChange={onChangeHandler}
                        placeholder="Enter zone name"
                        required
                    />
                </div>

                <div className="form-actions">
                    <button 
                        type="submit" 
                        className="submit-button" 
                        disabled={submitting}
                    >
                        {submitting ? "Processing..." : "Add Zone"}
                    </button>
                    <button
                        type="button"
                        onClick={() => navigate('/ViewZone')}
                        className="cancel-button"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Zone;